module.exports = __webpack_public_path__ + "img/map_1.4129af15.png";